import aesjs from 'aes-js';
import { pad } from 'pkcs7';

export default {
  methods: {
    encryptPassword(password) {
      const iv = aesjs.utils.utf8.toBytes('1234567891011121');
      const key = aesjs.utils.utf8.toBytes('871_jhH_d<9~ja$q');
      const text = aesjs.utils.utf8.toBytes(password);

      const aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
      const encryptedBytes = aesCbc.encrypt(pad(text));

      let binary = '';
      for (let iter = 0; iter < encryptedBytes.length; iter++) {
        binary += String.fromCharCode(encryptedBytes[iter]);
      }

      return btoa(binary);
    }
  }
};
